module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelTitleSection[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', {
    staticClass: "block-title push",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v("Sélection de l'organisation")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrganizationId),
      expression: "selectedOrganizationId"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOrganizationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getReportsHistory()
      }]
    }
  }, _vm._l((_vm.organizationList), function(organization) {
    return _c('option', {
      domProps: {
        "value": organization.OrganizationId
      }
    }, [_vm._v(_vm._s(organization.OrganizationName) + "       [" + _vm._s(organization.OrganizationId) + "]")])
  }), 0)]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Options Integrateur")]), _vm._v(" "), (_vm.integratorOptionsIsReading == false) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Integrateur parent:" + _vm._s(_vm.integratorParent))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.integratorOptions.activationFlag),
      expression: "integratorOptions.activationFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.integratorOptions.activationFlag) ? _vm._i(_vm.integratorOptions.activationFlag, null) > -1 : (_vm.integratorOptions.activationFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.integratorOptions.activationFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.integratorOptions, "activationFlag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.integratorOptions, "activationFlag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.integratorOptions, "activationFlag", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v(" Activation\r\n                            ")])]), _vm._v(" "), (_vm.integratorOptions.activationFlag) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v("Courriel de support")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.integratorOptions.supportEmail),
      expression: "integratorOptions.supportEmail"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.integratorOptions.supportEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.integratorOptions, "supportEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('h6', [_vm._v("Organisation Clients")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "size": "4",
      "multiple": ""
    }
  }, _vm._l((_vm.integratorOptions.integratedOrganizations), function(subOrganization, index) {
    return _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(subOrganization.organizationName) + " [" + _vm._s(subOrganization.organizationId) + "]")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('h6', [_vm._v("Commissions (%) par niveau (ne pas appliquer de décimales!)")]), _vm._v(" "), _vm._l((_vm.integratorOptions.commissions), function(commission, index2) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-2"
    }, [_c('h6', [_vm._v("Niveau " + _vm._s(index2 + 1))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.integratorOptions.commissions[index2]),
        expression: "integratorOptions.commissions[index2]"
      }],
      staticClass: "form-control align-center",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.integratorOptions.commissions[index2])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.integratorOptions.commissions, index2, $event.target.value)
        }
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 align-center"
  }, [_c('button', {
    staticClass: "btn align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addCommissionLevel()
      }
    }
  }, [_vm._v("Ajouter un niveau")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 align-center"
  }, [_c('button', {
    staticClass: "btn align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeCommissionLevel()
      }
    }
  }, [_vm._v("Retirer un niveau")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 align-center"
  }, [_c('button', {
    staticClass: "btn align-center",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveIntegratorOptions()
      }
    }
  }, [_vm._v("Enregistrer modifictions")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v("Rapports de commissions")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getReportsHistory()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonReadHistory[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelHistoryLength[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historyLength),
      expression: "historyLength"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.historyLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.historyLength = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.reportsIsReading) ? _c('spinner') : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportsList), function(report, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(report.report_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, _vm._l((report.linked_commissions), function(transaction) {
      return _c('p', [_vm._v(_vm._s(transaction.transactionId))])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('h6', [_vm._v(_vm._s(_vm.labelInvoiceAmount[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.total_amount) + " $")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.invoice_reference_number))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('label', {
      attrs: {
        "for": "example-checkbox1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.payment_done_by_evsens),
        expression: "report.payment_done_by_evsens"
      }],
      staticClass: "larger",
      attrs: {
        "type": "checkbox",
        "value": "option1"
      },
      domProps: {
        "checked": Array.isArray(report.payment_done_by_evsens) ? _vm._i(report.payment_done_by_evsens, "option1") > -1 : (report.payment_done_by_evsens)
      },
      on: {
        "change": function($event) {
          var $$a = report.payment_done_by_evsens,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "option1",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(report, "payment_done_by_evsens", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(report, "payment_done_by_evsens", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(report, "payment_done_by_evsens", $$c)
          }
        }
      }
    }), _vm._v("  Paiement fait\r\n                                            ")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.payment_reference_number),
        expression: "report.payment_reference_number"
      }],
      staticClass: "form-control align-center push",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (report.payment_reference_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(report, "payment_reference_number", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs align-center",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.saveReportReferenceNumber(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonInvoiceReferenceNumber[_vm.actualLanguage]))])])])
  }), 0)])])])], 1)])])]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7256ffd5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/evsens_admin/ViewEditIntegratorData.vue
// module id = 1566
// module chunks = 4